module.exports = __webpack_public_path__ + "img/2022-1.642f3baa.jpg";